import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media ${({ theme }) => theme.queries.minTablet} {
    width: 90%;
    margin-top: 16px;
  }
`;
